const IconComponent = (name: string):JSX.Element => {
    const NewIconComponent = name;
    return <NewIconComponent />
}


export default IconComponent;